import type { FaireProductEntity } from "../../entity_types/product";

export const p_he4mng6tuj: FaireProductEntity = {
  token: "p_he4mng6tuj",
  type: "product",
  name: "Liquid Iodine Plus 2oz",
  brandToken: "b_7gb3t4sxaw",
  brandName: "Life-Flo",
  imageUrl:
    "https://cdn.faire.com/fastly/f194c1205e63f18018fa86e1f846d21c3bc441e04899d8a7cfd6e400a674a063.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e87415603974e4d4e58a23b7d3a40344d9fdd3b55282a156fdbd4fe82ef87f26.jpeg",
    "https://cdn.faire.com/fastly/53f0183ff2d54894434bca9d7a44ac0d72ee6e8d89e959cf8228f1a3c9506649.jpeg",
    "https://cdn.faire.com/fastly/f9c217ddf9aa2c1d481834c9da5caf2f7ad182008d71c936be0e2b18644f462d.jpeg",
    "https://cdn.faire.com/fastly/4b26408d62feac8f673a9d34036e9342e35184bf483460084f26776d91138709.jpeg",
    "https://cdn.faire.com/fastly/56d88466a1a00ef3d3b2909e108fc157510136caa7236593f038af86a69724f5.jpeg",
    "https://cdn.faire.com/fastly/ca1bbb8828890ce27e82f62c7fb5aa5714e6cc0879c7926d925c90f909a4f548.jpeg",
    "https://cdn.faire.com/fastly/d7fdb9559f3195036d34ed94d46de15a75022e82f1a9f858f700b46c6114d44a.jpeg",
    "https://cdn.faire.com/fastly/e7870696dd019932801d2274fff2124172476ba902ef3bb34882887b146600ca.jpeg",
  ],
  priceDollars: 8.11,
  description:
    "If your thyroid in need of some attention? Just three drops of Life-flo Liquid Iodine Plus provide the recommended daily allowance of iodine, a trace mineral important to proper thyroid function, a healthy metabolism and proper energy levels to get you through the day.\n\nNo need to swallow pills. Our premium liquid supplement goes to work fast and may help support focus, concentration and healthy mental and physical energy and stamina. Formulated for enhanced absorption, with no fillers or binders, our iodine drops also contain potassium iodide, designed to help the body better utilize the iodine.\n\nMade in our own facilities, where we control all aspects of the manufacturing process, Life-flo Liquid Iodine Plus comes in unflavored or natural orange flavor, is easy to take and can be added to water or other beverages.",
  tags: [],
  msrpDollars: 16.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:44.750Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
